<nh-form [formGroup]="getForm()" [mode]="mode" (validate)="onValidate($event)">
  <h1 class="section-header">{{ "APPEAL_CATEGORY" | globalTranslate }}</h1>
  <hr />
  <section [formGroup]="getControl('data')">
    <div class="d-none d-lg-block">
      <table class="table w-100 table-striped">
        <thead>
          <tr>
            <th scope="col">{{ "Name" | globalTranslate }}</th>
            <th scope="col">{{ "PERSON_ID" | globalTranslate }}</th>
            <th scope="col">{{ "coverageType" | globalTranslate }}</th>
          </tr>
        </thead>
        <tbody formArrayName="appealCategory">
          @for (coverage of appealCategory.controls; track coverage; let i =
          $index) {
          <tr [formGroupName]="i">
            <td>{{ appealCategoryValues[i].memberName }}</td>
            <td>{{ appealCategoryValues[i].personId }}</td>
            <td>
              <nh-field id="coverageType" [isRow]="true">
                <select
                  nh
                  name="selectedCoverageType"
                  formControlName="selectedCoverageType"
                  [attr.aria-label]="'coverageType' | globalTranslate"
                  [items]="appealCategoryValues[i].availableCoverageTypes"
                  empty="Pick an option"
                ></select>
              </nh-field>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="nh-table-mobile d-lg-none">
      <div formArrayName="appealCategory">
        @for (coverage of appealCategory.controls; track coverage; let i =
        $index) {
        <div class="table-row mb-3 pb-3" [formGroupName]="i">
          <div class="mobile-table-header">
            {{ selectAppelantsColumns[0].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ appealCategoryValues[i].memberName }}
          </div>
          <br />
          <div class="mobile-table-header">
            {{ selectAppelantsColumns[1].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ appealCategoryValues[i].personId }}
          </div>
          <br />
          <div class="mobile-table-header">
            {{ coverageType | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            <select
              nh
              name="selectedCoverageType"
              formControlName="selectedCoverageType"
              [attr.aria-label]="'coverageType' | globalTranslate"
              [items]="appealCategoryValues[i].availableCoverageTypes"
              empty="Pick an option"
            ></select>
          </div>
        </div>
        }
      </div>
    </div>
    <!--Eligibility Appeal-->
    @if (isEnabled('data.nursingFacilityOrHCBS')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT14' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="nursingFacilityOrHCBS"
            [items]="tableCodeValue('APFACILITY', 'data.nursingFacilityOrHCBS')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT14' | globalTranslate"
            formControlName="nursingFacilityOrHCBS"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.benefitChgTxt')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT1' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="benefitChgTxt"
              formControlName="benefitChgTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT1' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.applyDateSW')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{
            'APPEAL_DETAILS_FORM_TEXT10'
              | translate: { date: applyDateForBenefit | globalTranslate }
          }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="applyDateSW"
            [items]="tableCodeValue('YESNO', 'data.applyDateSW')"
            [attr.aria-label]="
              'APPEAL_DETAILS_FORM_TEXT10'
                | translate: { date: applyDateForBenefit | globalTranslate }
            "
            formControlName="applyDateSW"
            (change)="onChange('applyDateSW')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if ((isN('data.applyDateSW')) && isEnabled('data.applyDateRangeTxt')) {
    <div class="row">
      <div class="col">
        <p
          class="static-text"
          [innerHTML]="'APPEAL_DETAILS_FORM_TEXT6' | globalTranslate"
        ></p>
        <nh-field
          label
          class="label-section"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <input
            (input)="onInput($event)"
            maxlength="25"
            type="text"
            placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
            name="applyDateRangeTxt"
            [attr.aria-label]="
              'aria_label_APPEAL_DETAILS_FORM_TEXT6' | globalTranslate
            "
            class="form-control"
            required
          />
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.denialSW')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT7' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="denialSW"
            [items]="tableCodeValue('YESNO', 'data.denialSW')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT7' | globalTranslate"
            formControlName="denialSW"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.denialTxt') && this.appealReasonCode !== 'FD' &&
    this.appealReasonCode !== 'D') {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT8' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="denialTxt"
              formControlName="denialTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT8' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.appealFilingLocation')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT11' | globalTranslate }}"
          class="label-section"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <input
            (input)="onInput($event)"
            maxlength="25"
            type="text"
            placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
            name="appealFilingLocation"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT11' | globalTranslate"
            formControlName="appealFilingLocation"
            class="form-control"
            required
          />
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.elgBeginDate')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT12' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-datepicker>
            <input
              type="text"
              name="elgBeginDate"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT12' | globalTranslate"
              formControlName="elgBeginDate"
              class="form-control"
              bsDatepicker
              nh
              [minDate]="minimumDate"
              [maxDate]="today"
              required
            />
          </nh-datepicker>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.elgEffectiveDateTxt')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT13' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="elgEffectiveDateTxt"
              formControlName="elgEffectiveDateTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT13' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.patientLiabilityTxt')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT15' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="patientLiabilityTxt"
              formControlName="patientLiabilityTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT15' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.premiumAmount')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT17' | globalTranslate }}"
          class="label-section"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-input-group prepend="$">
            <input
              nh
              type="text"
              placeholder="0.00"
              mask="separator.2"
              thousandSeparator=""
              separatorLimit="999999999"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT17' | globalTranslate"
              name="premiumAmount"
              formControlName="premiumAmount"
              class="form-control"
              required
            />
          </nh-input-group>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.renewalPktSw')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT19' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="renewalPktSw"
            [items]="tableCodeValue('YESNO', 'data.renewalPktSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT19' | globalTranslate"
            formControlName="renewalPktSw"
            (change)="onChange('renewalPktSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if ((isY('data.renewalPktSw')) &&
    isEnabled('data.sendCompletedPacketSw')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT20' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="sendCompletedPacketSw"
            [items]="tableCodeValue('YESNO', 'data.sendCompletedPacketSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT20' | globalTranslate"
            formControlName="sendCompletedPacketSw"
            (change)="onChange('sendCompletedPacketSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if ((isY('data.sendCompletedPacketSw'))) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT21' | globalTranslate }}"
          [mandatory]="packetReturnDateValidation"
          [attr.aria-required]="packetReturnDateValidation"
        >
          <nh-datepicker>
            <input
              type="text"
              name="packetReturnDate"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT21' | globalTranslate"
              formControlName="packetReturnDate"
              class="form-control"
              bsDatepicker
              nh
              [minDate]="minimumDate"
              [maxDate]="today"
            />
          </nh-datepicker>
        </nh-field>
      </div>
    </div>
    } @if ((isY('data.sendCompletedPacketSw'))) {
    <div class="row">
      <div class="col">
        @if (!isEnabled('data.packetReturnDateRangeTxt')) {
        <p
          class="static-text"
          [innerHTML]="'APPEAL_DETAILS_FORM_TEXT38' | globalTranslate"
        ></p>
        } @if (isEnabled('data.packetReturnDateRangeTxt')) {
        <p
          class="static-text"
          [innerHTML]="'APPEAL_DETAILS_FORM_TEXT42' | globalTranslate"
        ></p>
        }
        <nh-field label class="label-section">
          <input
            (input)="onInput($event)"
            maxlength="25"
            type="text"
            placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
            name="packetReturnDateRangeTxt"
            [attr.aria-label]="
              'aria_label_APPEAL_DETAILS_FORM_TEXT6' | globalTranslate
            "
            formControlName="packetReturnDateRangeTxt"
            class="form-control"
            (change)="onChange('packetReturnDateRangeTxt')"
            aria-required="true"
          />
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.otherPeopleListedSw')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT22' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="otherPeopleListedSw"
            [items]="tableCodeValue('YESNO', 'data.otherPeopleListedSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT22' | globalTranslate"
            formControlName="otherPeopleListedSw"
            (change)="onChange('otherPeopleListedSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if ((((isY('data.sendCompletedPacketSw') &&
    isY('data.otherPeopleListedSw')) && isEnabled('data.packetNamesList')) ||
    (appealReasonCode === 'FV' && isEnabled('data.packetNamesList')))) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT23' | globalTranslate }}"
          [mandatory]="false"
          [attr.aria-required]="false"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="500"
              placeholder="Name 1, Name 2, Name 3, etc..."
              class="form-control"
              name="packetNamesList"
              formControlName="packetNamesList"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT23' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    } @if ((isY('data.sendCompletedPacketSw')) &&
    isEnabled('data.packetSendType')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT24' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="packetSendType"
            [items]="tableCodeValue('APLFILINGMETHOD', 'data.packetSendType')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT24' | globalTranslate"
            formControlName="packetSendType"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.letterReceivedMoreInfoSw')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT25' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="letterReceivedMoreInfoSw"
            [items]="tableCodeValue('YESNO', 'data.letterReceivedMoreInfoSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT25' | globalTranslate"
            formControlName="letterReceivedMoreInfoSw"
            (change)="onChange('letterReceivedMoreInfoSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if ((isY('data.letterReceivedMoreInfoSw')) &&
    isEnabled('data.requestedInfoSentSw')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT26' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="requestedInfoSentSw"
            [items]="tableCodeValue('YESNO', 'data.requestedInfoSentSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT26' | globalTranslate"
            formControlName="requestedInfoSentSw"
            (change)="onChange('requestedInfoSentSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if ((isY('data.requestedInfoSentSw'))) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT27' | globalTranslate }}"
          [mandatory]="addInfoSentDateValidation"
          [attr.aria-required]="addInfoSentDateValidation"
        >
          <nh-datepicker>
            <input
              type="text"
              name="addInfoSentDate"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT27' | globalTranslate"
              formControlName="addInfoSentDate"
              class="form-control"
              bsDatepicker
              nh
              [minDate]="minimumDate"
              [maxDate]="today"
            />
          </nh-datepicker>
        </nh-field>
      </div>
    </div>
    } @if ((isY('data.requestedInfoSentSw'))) {
    <div class="row">
      <div class="col">
        @if (!isEnabled('data.addInfoDateRangeTxt')) {
        <p
          class="static-text"
          [innerHTML]="'APPEAL_DETAILS_FORM_TEXT38' | globalTranslate"
        ></p>
        } @if (isEnabled('data.addInfoDateRangeTxt')) {
        <p
          class="static-text"
          [innerHTML]="'APPEAL_DETAILS_FORM_TEXT43' | globalTranslate"
        ></p>
        }
        <nh-field label class="label-section">
          <input
            (input)="onInput($event)"
            maxlength="25"
            type="text"
            placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
            name="addInfoDateRangeTxt"
            [attr.aria-label]="
              'aria_label_APPEAL_DETAILS_FORM_TEXT6' | globalTranslate
            "
            formControlName="addInfoDateRangeTxt"
            class="form-control"
            (change)="onChange('addInfoDateRangeTxt')"
            required
          />
        </nh-field>
      </div>
    </div>
    } @if ((isY('data.requestedInfoSentSw')) &&
    isEnabled('data.addInfoSentType')) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT28' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="addInfoSentType"
            [items]="tableCodeValue('APLFILINGMETHOD', 'data.addInfoSentType')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT28' | globalTranslate"
            formControlName="addInfoSentType"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.denialTxt') && (this.appealReasonCode === 'FD' ||
    this.appealReasonCode==='D')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT44' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="denialTxt"
              formControlName="denialTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT44' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.terminationIncorrectTxt')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT18' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="terminationIncorrectTxt"
              formControlName="terminationIncorrectTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT18' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.cvgSuspensionBeginDate')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT30' | globalTranslate }}"
          [mandatory]="false"
          [attr.aria-required]="false"
        >
          <nh-datepicker>
            <input
              type="text"
              name="cvgSuspensionBeginDate"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT30' | globalTranslate"
              formControlName="cvgSuspensionBeginDate"
              class="form-control"
              bsDatepicker
              nh
              [minDate]="minimumDate"
              [maxDate]="today"
            />
          </nh-datepicker>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.cvgSuspensionEndDate')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT31' | globalTranslate }}"
          [mandatory]="false"
          [attr.aria-required]="false"
        >
          <nh-datepicker>
            <input
              type="text"
              name="cvgSuspensionEndDate"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT31' | globalTranslate"
              formControlName="cvgSuspensionEndDate"
              class="form-control"
              bsDatepicker
              nh
              [minDate]="minimumDate"
              [maxDate]="today"
            />
          </nh-datepicker>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.qualifyHardshipAndAssistanceTxt')) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT32' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="qualifyHardshipAndAssistanceTxt"
              formControlName="qualifyHardshipAndAssistanceTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT32' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    } @if (isEnabled('data.changeInCvgIncorrectTxt') && this.appealReasonCode
    === 'FC') {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT45' | globalTranslate }}"
          [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT45' | globalTranslate"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="changeInCvgIncorrectTxt"
              formControlName="changeInCvgIncorrectTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT45' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    }
    <!--common field-->
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT2' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="appealReasonTxt"
              formControlName="appealReasonTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT2' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    <!--common field-->
    <div class="row">
      <div class="col">
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT3' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="elgNoticeIssuesSw"
            [items]="tableCodeValue('YESNO', 'data.elgNoticeIssuesSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT3' | globalTranslate"
            formControlName="elgNoticeIssuesSw"
            (change)="onChange('elgNoticeIssuesSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    <!--common field-->
    @if ((isY('data.elgNoticeIssuesSw'))) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT4' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="1000"
              minlength="20"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="elgNoticeIssuesTxt"
              formControlName="elgNoticeIssuesTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT4' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    }
    <!--common field-->
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT33' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="appellantPregnantOrChildSw"
            [items]="tableCodeValue('YESNO', 'data.appellantPregnantOrChildSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT33' | globalTranslate"
            formControlName="appellantPregnantOrChildSw"
            (change)="onChange('appellantPregnantOrChildSw')"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    <!--common field-->
    @if ((isY('data.appellantPregnantOrChildSw'))) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT34' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="priorMedServReceivedSw"
            [items]="tableCodeValue('YESNO', 'data.priorMedServReceivedSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT34' | globalTranslate"
            formControlName="priorMedServReceivedSw"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    }
    <!--common field-->
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT35' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="filingWithin90DaysPregSw"
            [items]="tableCodeValue('YESNO', 'data.filingWithin90DaysPregSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT35' | globalTranslate"
            formControlName="filingWithin90DaysPregSw"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    <!--common field-->
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT36' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="newBornSw"
            [items]="tableCodeValue('YESNO', 'data.newBornSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT36' | globalTranslate"
            formControlName="newBornSw"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    <!--common field-->
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT39' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="appealIssueSame"
            [items]="tableCodeValue('YESNO', 'data.appealIssueSame')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT39' | globalTranslate"
            formControlName="appealIssueSame"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    <!--common field-->
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT40' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <select
            nhTranslate
            name="previousFiledAppeal"
            [items]="tableCodeValue('YESNO', 'data.previousFiledAppeal')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT40' | globalTranslate"
            formControlName="previousFiledAppeal"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    <!--common field-->
    @if ((isY('data.previousFiledAppeal'))) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT41' | globalTranslate }}"
          [mandatory]="false"
          [attr.aria-required]="false"
        >
          <nh-count>
            <textarea
              (input)="onAppealNumberInput($event)"
              maxlength="250"
              placeholder="{{ appealNumberPlaceHolder | globalTranslate }}"
              class="form-control"
              name="enterAppealNum"
              formControlName="enterAppealNum"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT41' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    }
    <!--common field-->
    @if (isCommanQestEnabled) {
    <div class="row">
      <div class="col">
        <nh-field
          class="label-section"
          label="{{ 'APPEAL_DETAILS_FORM_TEXT46' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <div class="nh-tooltip" aria-hidden="true">
            <span
              ><a class="toolTip">
                <img
                  [src]="'assets/images/Icons/tool-tip-icon.svg'"
                  alt="tooltip" /></a
            ></span>
            <span
              class="tooltiptext"
              [innerHTML]="'APPEAL_DETAILS_FORM_TEXT50' | globalTranslate"
              placement="auto"
            ></span>
          </div>
          <span class="visually-hidden" aria-hidden="false">
            {{ "INFORMATION_tooltip" | globalTranslate }}
            {{ "APPEAL_DETAILS_FORM_TEXT50" | globalTranslate }}</span
          >
          <p
            class="static-text"
            [innerHTML]="'APPEAL_DETAILS_FORM_TEXT49' | globalTranslate"
          ></p>
          <select
            nhTranslate
            name="aplDeadlineMissedSw"
            (change)="onChange('aplDeadlineMissedSw')"
            [items]="tableCodeValue('YESNOIDK', 'data.aplDeadlineMissedSw')"
            [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT46' | globalTranslate"
            formControlName="aplDeadlineMissedSw"
            required
          ></select>
        </nh-field>
      </div>
    </div>
    }
    <!--common field-->
    @if (isCommanQestEnabled && ((isY('data.aplDeadlineMissedSw') ||
    isIDK('data.aplDeadlineMissedSw')))) {
    <div class="row">
      <div class="col">
        <nh-field
          label="{{ 'APPEAL_DETAILS_FORM_TEXT47' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
        >
          <br />
          <span
            class="static-text"
            [innerHTML]="'APPEAL_DETAILS_FORM_TEXT48' | globalTranslate"
          ></span>
          <nh-count>
            <textarea
              (input)="onInput($event)"
              maxlength="4000"
              placeholder="{{ startTypingPlaceHolder | globalTranslate }}"
              class="form-control"
              name="aplDeadlineMissedReasonTxt"
              formControlName="aplDeadlineMissedReasonTxt"
              [attr.aria-label]="'APPEAL_DETAILS_FORM_TEXT47' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 0px"
              required
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
    </div>
    }
  </section>
</nh-form>